// extracted by mini-css-extract-plugin
export default {"root":"LayoutPC_root__xi12D","left":"LayoutPC_left__BgdSX","right":"LayoutPC_right__lWkvW"};